var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUnsecured(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 58,
    viewBox: "0 0 40 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.67 6.933c-4.614-1.977-9.226-3.852-13.84-5.728-1.013-.406-2.027-.304-2.99.152-2.23.938-4.448 1.863-6.666 2.788l-1.376.574 2.61 2.61c1.407-.594 2.811-1.195 4.21-1.793l1.83-.783c.71-.304 1.369-.304 2.079 0 1.976.837 3.966 1.66 5.956 2.484 1.99.824 3.98 1.648 5.956 2.484.659.254 1.065.608 1.014 1.42-.236 5.006-1.327 9.62-3.582 13.65l2.505 2.506c2.864-4.697 4.298-10.13 4.575-16.46.202-1.217-.153-3.042-2.282-3.904zM4.6 6.894l-.966-.966a1.812 1.812 0 112.563-2.562l26.658 26.658a1.812 1.812 0 01-2.562 2.563l-1.061-1.06c-.57.637-1.173 1.26-1.811 1.867-1.724 1.673-3.7 3.041-5.88 4.156-1.42.76-2.738.76-4.157.051-4.917-2.484-8.567-6.235-11.254-11-2.788-4.967-4.055-10.34-4.055-16.069.05-1.825.862-2.94 2.433-3.599l.092-.039zm22.203 22.203a25.923 25.923 0 01-3.742 3.435l-.5.374c-1.447 1.087-2.203 1.655-2.973 1.672-.841.02-1.698-.62-3.494-1.962l-.18-.135C9.679 27.868 6.688 21.33 5.776 13.776a7.964 7.964 0 00-.102-.583c-.038-.19-.076-.38-.101-.582a3.736 3.736 0 01-.012-.71 7.47 7.47 0 00.012-.355c-.304-1.166.304-1.571 1.368-1.977l.24-.094 19.622 19.622z",
    fill: "current"
  })));
}

export default SvgIconUnsecured;